import __request__ from "routing/request";
export function total() {
  return __request__("GET", "/system/throughput", null, {}, {
    "Accept": ["application/json"]
  });
}
